import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { InputFieldComponent } from '../../../../components/form/input-field/input-field.component';
import { AbstractControl, Form, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { AlertNotificationService } from '../../../../services/alert-notification.service';
import { AlertInfo } from '../../../../models/alert-info';
import { NgbAlert, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { FormService } from '../../../../services/form.service';
import { SavedDataInfo } from '../../../../models/form/saved-data-info';
import { CustomerService } from '../../../../services/api/customer.service';
import { ActivatedRoute } from '@angular/router';
import { OptionService } from 'src/app/services/api/option.service';
import { forkJoin, Observable, switchMap, of } from 'rxjs';
import { CommonService } from 'src/app/services/common.service';
import { ConfirmationDialogService } from '../../../../services/confirmation-dialog.service';

interface ContactForm {
  customerPersonId: FormControl<number | null>;
  firstName: FormControl<string | null>;
  lastName: FormControl<string | null>;
  email: FormControl<string | null>;
  phone: FormControl<string | null>;
  msteamsId: FormControl<string | null>;
}
@Component({
  selector: 'contacts-customers-form',
  imports: [CommonModule, ReactiveFormsModule, InputFieldComponent, NgbAlert, NgbTooltipModule],
  templateUrl: './contacts-customers-form.component.html',
  styleUrl: './contacts-customers-form.component.scss'
})
export class FormContactsCustomersComponent implements OnInit {
  @Input() clientPersons: any[] = [];
  @Input() clientId!: number;
  @Input() readonlyContactsCustomer!: boolean
  @Input() inCustomerDetailPage: boolean = false;
  @Input() hideActionsColumn: boolean = false;
  @Input() isCreating: boolean = false;
  @Output() onSavedData = new EventEmitter<SavedDataInfo>();


  formAdministrators!: FormGroup;
  formCompanyOwner!: FormGroup;
  formProjectManager!: FormGroup;
  formTechnicalResponsible!: FormGroup;

  showConfirmation: boolean = false;
  message: string = '';
  itemToBeDeleted!: FormArray<FormArray>;
  indexItemToBeDeleted: number = 0;
  alertInfo: AlertInfo = { show: false, type: '', message: '' };

  contactsByRole: { [key: string]: any[] } = {};
  manageRoles:any[] = [];

  existingContacts: any[] = [];

  private previousDecisionMakerId: number | null = null;

  constructor(
    private fb: FormBuilder,
    private alertNotificationService: AlertNotificationService,
    private formService: FormService,
    private customersService: CustomerService,
    private route: ActivatedRoute,
    private optionService: OptionService,
    private commonService: CommonService,
    private confirmationDialogService: ConfirmationDialogService,
    private elRef: ElementRef
  ) {
    this.initializeForms();
  }
  ngOnInit(): void {
    if (!this.isCreating) {
      const clientsId = this.route.snapshot.paramMap.get('clientsId');
      this.clientId = Number(clientsId);
    }
    setTimeout(() => {
      if (this.clientPersons?.length > 0) {
        this.initializeFormArrays();
        this.existingContacts= this.clientPersons
      }
    }, 800);

    this.optionService.clientsRoles().subscribe({
      next: (response: any) => {
        if (response.status.code === 200) {
          const roles = response.data.options
;
          console.log(roles);
          console.log(response);
          this.manageRoles = roles;
        }
      },
      error: (error: any) => {
        console.error('Error fetching client roles:', error);
      }
    });
  }

  ngOnChanges(): void {
    if (Array.isArray(this.clientPersons)) {
      this.groupContactsByRole();
      this.populateFormArrays();
    }
  }

  private initializeForms() {
    const roles = ['COMPANY_OWNER', 'ADMINISTRATION', 'PROJECT_MANAGER', 'TECHNICAL_RESPONSIBLE'];

    roles.forEach(role => {
        this.contactsByRole[role] = [];
    });

    this.formAdministrators = this.fb.group({
        contacts: this.fb.array([])
    });

    this.formCompanyOwner = this.fb.group({
        contacts: this.fb.array([])
    });

    this.formProjectManager = this.fb.group({
        contacts: this.fb.array([])
    });

    this.formTechnicalResponsible = this.fb.group({
        contacts: this.fb.array([])
    });
  }

  private groupContactsByRole(): void {
    this.contactsByRole = this.clientPersons.reduce((acc: { [key: string]: any[] }, contact: any) => {
      if (!acc[contact.role]) {
        acc[contact.role] = [];
      }
      acc[contact.role].push(contact);
      return acc;
    }, {});
  }

  onDecisionMakerChange(selectedContact: AbstractControl, event: Event): void {
    const isChecked = (event.target as HTMLInputElement).checked;

    if (!isChecked) {
      const selectedControl = selectedContact.get('isDecisionMaker');
      if (selectedControl instanceof FormControl) {
        selectedControl.setValue(false);
      }
      return;
    }

    const formArrays = [
      this.getCompanyOwnerArray(),
      this.getAdministratorsArray(),
      this.getProjectManagerArray(),
      this.getTechnicalResponsibleArray(),
    ];

    formArrays.forEach((formArray) => {
      formArray.controls.forEach((group: AbstractControl) => {
        const isDecisionMakerControl = group.get('isDecisionMaker');
        if (isDecisionMakerControl instanceof FormControl) {
          isDecisionMakerControl.setValue(group === selectedContact, { emitEvent: false });
        }
      });
    });
  }

  /**
       * *******************
       * Submit form methods
       * *******************
       */
  showAlertInfo(type: string, message: string) {
    this.alertInfo = {
      show: true,
      type,
      message
    }
    const top = this.elRef.nativeElement.getBoundingClientRect().top + window.scrollY;
    window.scrollTo({ top, behavior: 'smooth' });
    setTimeout(() => {
      this.alertInfo.show = false;
    }, 3000);
  }
  updateValidationErrors(validationErrors: any) {
    this.formService.resetErrors(this.formAdministrators);
    this.formService.setValidationErrors(this.formAdministrators, validationErrors);

    this.formService.resetErrors(this.formCompanyOwner);
    this.formService.setValidationErrors(this.formCompanyOwner, validationErrors);

    this.formService.resetErrors(this.formProjectManager);
    this.formService.setValidationErrors(this.formProjectManager, validationErrors);

    this.formService.resetErrors(this.formTechnicalResponsible);
    this.formService.setValidationErrors(this.formTechnicalResponsible, validationErrors);
  }
  submitFormSuccess(response: any) {
    this.alertNotificationService.success('Operation completed successfully')
    this.showAlertInfo('success', 'Operation completed successfully');

    this.onSavedData.emit({
      success: true,
      response
    });
  }

  loadClientPersons() {
    this.customersService.listClientPersons(this.clientId).subscribe({
      next: (response: any) => {
        if (response.status.code === 200) {
          this.clientPersons = response.data.customerPersons || [];
          this.existingContacts = this.clientPersons;

          this.groupContactsByRole();
          this.populateFormArrays();
        }
      },
      error: (error: any) => {
        console.error('Error loading client persons:', error);
      }
    });
  }
  submitFormError(error: any) {

    if (error.error.error.description == 'ARGUMENT_VALIDATION_ERROR') {
      this.updateValidationErrors(error.error.error.validationErrors);
    }
    else if (error.error.error.description == 'USER_EMAIL_ALREADY_EXISTS') {
      this.updateValidationErrors([{ field: 'email', defaultMessage: error.error.error.message }]);
      this.showAlertInfo('danger', `Please fix the error: ${error.error.error.message}`);
    }
    else {
      this.showAlertInfo('danger', error.error.error.message);
    }

    this.onSavedData.emit({
      success: false,
      error
    });

  }
  private markFormGroupTouched(formGroup: FormGroup | FormArray): void {
    if (formGroup instanceof FormGroup) {
      Object.keys(formGroup.controls).forEach(key => {
        const control = formGroup.get(key);

        if (control instanceof FormControl) {
          control.markAsTouched();
          control.updateValueAndValidity();
        } else if (control instanceof FormGroup || control instanceof FormArray) {
          this.markFormGroupTouched(control);
        }
      });
    } else if (formGroup instanceof FormArray) {
      formGroup.controls.forEach(control => {
        if (control instanceof FormControl) {
          control.markAsTouched();
          control.updateValueAndValidity();
        } else if (control instanceof FormGroup || control instanceof FormArray) {
          this.markFormGroupTouched(control);
        }
      });
    }
  }

  validateAllForms(): boolean {
    this.markFormGroupTouched(this.formAdministrators);
    this.markFormGroupTouched(this.formCompanyOwner);
    this.markFormGroupTouched(this.formProjectManager);
    this.markFormGroupTouched(this.formTechnicalResponsible);

    return (
      this.formAdministrators.valid &&
      this.formCompanyOwner.valid &&
      this.formProjectManager.valid &&
      this.formTechnicalResponsible.valid
    );
  }
  submitForm(): void {
    const allFormsValid = this.validateAllForms();

    if (allFormsValid) {
      this.alertInfo.show = false;
      this.formService.resetErrors(this.formAdministrators);
      this.formService.resetErrors(this.formCompanyOwner);
      this.formService.resetErrors(this.formProjectManager);
      this.formService.resetErrors(this.formTechnicalResponsible);

      const allContacts = [
        ...this.getCompanyOwnerArray().value.map((contact: any) => ({ ...contact, role: 'COMPANY_OWNER' })),
        ...this.getAdministratorsArray().value.map((contact: any) => ({ ...contact, role: 'ADMINISTRATION' })),
        ...this.getProjectManagerArray().value.map((contact: any) => ({ ...contact, role: 'PROJECT_MANAGER' })),
        ...this.getTechnicalResponsibleArray().value.map((contact: any) => ({ ...contact, role: 'TECHNICAL_RESPONSIBLE' })),
      ];

      const decisionMakerCount = allContacts.filter(contact => contact.isDecisionMaker === true).length;
      if (decisionMakerCount !== 1) {
        const message = decisionMakerCount === 0
          ? 'At least one contact must be marked as Decision Maker'
          : 'Only one contact can be marked as Decision Maker';
        this.showAlertInfo('danger', message);
        this.alertNotificationService.error(message);
        return;
      } else {
        const saveRequests: Observable<any>[] = [];

        allContacts?.forEach((contact) => {
          const data = {
            customerPersonId: contact?.customerPersonId,
            role: contact.role,
            firstName: contact.firstName,
            lastName: contact.lastName,
            email: contact.email,
            phone: contact.phone,
            msteamsId: contact.msteamsId,
            isDecisionMaker: contact.isDecisionMaker,
          };

          if (data.customerPersonId) {
            saveRequests.push(this.customersService.updateClientPersons(this.clientId, data.customerPersonId, data));
          } else {
            saveRequests.push(this.customersService.createClientPersons(this.clientId, data));
          }
        });

        if (saveRequests.length > 0) {
          const prevId = this.previousDecisionMakerId;
          const prevDmContact = prevId
            ? allContacts.find(c => c.customerPersonId === prevId && c.isDecisionMaker === false)
            : null;

          if (prevDmContact) {
            const prevDmData = {
              customerPersonId: prevDmContact.customerPersonId,
              role: prevDmContact.role,
              firstName: prevDmContact.firstName,
              lastName: prevDmContact.lastName,
              email: prevDmContact.email,
              phone: prevDmContact.phone,
              msteamsId: prevDmContact.msteamsId,
              isDecisionMaker: false,
            };

            const remainingRequests = saveRequests.filter((_, i) => {
              const c = allContacts[i];
              return c.customerPersonId !== prevId;
            });

            this.customersService.updateClientPersons(this.clientId, prevDmContact.customerPersonId, prevDmData)
              .pipe(
                switchMap(() => remainingRequests.length > 0 ? forkJoin(remainingRequests) : of([]))
              )
              .subscribe({
                next: (responses: any) => {
                  this.alertNotificationService.success('Operation completed successfully');
                  this.showAlertInfo('success', 'Operation completed successfully');
                  this.loadClientPersons();
                  this.onSavedData.emit({ success: true, response: responses });
                },
                error: (error: any) => {
                  this.submitFormError(error);
                }
              });
          } else {
            forkJoin(saveRequests).subscribe({
              next: (responses: any[]) => {
                this.alertNotificationService.success('Operation completed successfully');
                this.showAlertInfo('success', 'Operation completed successfully');
                this.loadClientPersons();
                this.onSavedData.emit({ success: true, response: responses });
              },
              error: (error: any) => {
                this.submitFormError(error);
              }
            });
          }
        }
      }
    }
  }
  /**
   * *******************
   * Submit form methods
   * *******************
   */

  isFormValid(): boolean {
    return this.formAdministrators.valid && this.formCompanyOwner.valid && this.formProjectManager.valid && this.formTechnicalResponsible.valid;
  }

  validateContactsForCreate(): boolean {
    if (!this.hasAnyContact()) {
      return false;
    }
    this.markFormGroupTouched(this.formAdministrators);
    this.markFormGroupTouched(this.formCompanyOwner);
    this.markFormGroupTouched(this.formProjectManager);
    this.markFormGroupTouched(this.formTechnicalResponsible);
    if (!this.validateAllForms()) {
      return false;
    }
    const allContacts = this.getAllContactValues();
    const decisionMakerCount = allContacts.filter((c: any) => c.isDecisionMaker === true).length;
    return decisionMakerCount === 1;
  }

  private getAllContactValues(): any[] {
    return [
      ...this.getCompanyOwnerArray().value.map((c: any) => ({ ...c, role: 'COMPANY_OWNER' })),
      ...this.getAdministratorsArray().value.map((c: any) => ({ ...c, role: 'ADMINISTRATION' })),
      ...this.getProjectManagerArray().value.map((c: any) => ({ ...c, role: 'PROJECT_MANAGER' })),
      ...this.getTechnicalResponsibleArray().value.map((c: any) => ({ ...c, role: 'TECHNICAL_RESPONSIBLE' })),
    ];
  }

  saveContactsForNewClient(clientId: number): Observable<any> {
    this.clientId = clientId;
    const allContacts = this.getAllContactValues();
    const saveRequests: Observable<any>[] = allContacts.map((contact: any) => {
      const data = {
        role: contact.role,
        firstName: contact.firstName,
        lastName: contact.lastName,
        email: contact.email,
        phone: contact.phone,
        msteamsId: contact.msteamsId,
        isDecisionMaker: contact.isDecisionMaker,
      };
      return this.customersService.createClientPersons(clientId, data);
    });
    return saveRequests.length > 0 ? forkJoin(saveRequests) : of([]);
  }

  private initializeFormArrays() {
    if (this.clientPersons.length > 0) {
        const contacts = this.clientPersons[0];
        this.initializeFormArray(contacts.administrations, this.getAdministratorsArray());
        this.initializeFormArray(contacts.companyOwner, this.getCompanyOwnerArray());
        this.initializeFormArray(contacts.projectManager, this.getProjectManagerArray());
    }
}

  private initializeFormArray(data: any[], formArray: FormArray) {
    if (data && data.length > 0) {
      data.forEach(contact => {
        formArray.push(this.createContactFormGroup(contact));
      });
    }
  }

  private createContactFormGroup(contact: any = {}) {
    return this.fb.group({
      customerPersonId: [contact.customerPersonId || null],
      firstName: [contact.firstName || '', [Validators.required]],
      lastName: [contact.lastName || '', [Validators.required]],
      email: [contact.email || '', [Validators.required, Validators.email]],
      phone: [contact.phone || '', [Validators.required]],
      msteamsId: [contact.msteamsId || ''],
      isDecisionMaker: [contact.isDecisionMaker || false]
    }) as FormGroup<ContactForm & { isDecisionMaker: FormControl<boolean> }>;
  }
  getFormControl(group: AbstractControl, controlName: string): FormControl {
    if (group instanceof FormGroup) {
      return group.get(controlName) as FormControl;
    } else {
      console.error('Invalid group passed to getFormControl:', group);
      throw new Error('Invalid group passed to getFormControl');
    }
  }
  getSafeFormControl(group: AbstractControl, controlName: string): FormControl {
    const control = group.get(controlName);
    if (control instanceof FormControl) {
      return control;
    }
    return new FormControl();
  }

  getAdministratorsArray() {
    return this.formAdministrators.get('contacts') as FormArray;
  }

  getCompanyOwnerArray() {
    return this.formCompanyOwner.get('contacts') as FormArray;
  }

  getProjectManagerArray() {
    return this.formProjectManager.get('contacts') as FormArray;
  }

  getTechnicalResponsibleArray() {
    return this.formTechnicalResponsible.get('contacts') as FormArray;
  }

  addNewContact(role: any) {
    switch (role) {
      case 'COMPANY_OWNER':
        return this.getCompanyOwnerArray().push(this.createContactFormGroup());
      case 'ADMINISTRATION':
        return this.getAdministratorsArray().push(this.createContactFormGroup());
      case 'PROJECT_MANAGER':
        return this.getProjectManagerArray().push(this.createContactFormGroup());
      case 'TECHNICAL_RESPONSIBLE':
        return this.getTechnicalResponsibleArray().push(this.createContactFormGroup());
      default:
        throw new Error(`Unknown role: ${role}`);
    }
  }

  removeContact(formArray: FormArray, index: number) {
    const contact = formArray.at(index).value;

    if (!contact.customerPersonId) {
      formArray.removeAt(index);
      this.alertNotificationService.success('Contact removed');
    } else {
      this.customersService.deleteClientPersons(this.clientId, contact.customerPersonId).subscribe({
        next: () => {
          formArray.removeAt(index);
          this.alertNotificationService.success('Contact deleted successfully');

          this.loadClientPersons();
        },
        error: (error) => {
          this.alertNotificationService.error('Failed to delete contact');
          console.error('Error deleting contact:', error);
        },
      });
    }
  }
  confirmDelete(formArray: FormArray, index: number, item: any) {
    this.itemToBeDeleted = formArray;
    this.indexItemToBeDeleted = index;
    this.confirmationDialogService.open(
      `Are you confident in your decision to delete <b>${item.firstName} ${item.lastName}</b>?`,
      () => this.removeContact(formArray, index)
    );
  }

  private populateFormArrays(): void {
    const roles = ['COMPANY_OWNER', 'ADMINISTRATION', 'PROJECT_MANAGER', 'TECHNICAL_RESPONSIBLE'];

    roles.forEach(role => {
        const formArray = this.getFormArrayByRole(role);
        formArray.clear();

        if (this.contactsByRole[role]) {
            this.contactsByRole[role].forEach(contact => {
                formArray.push(this.createContactFormGroup(contact));
            });
        }
    });

    this.previousDecisionMakerId = null;
    const decisionMaker = this.clientPersons.find(c => c.isDecisionMaker === true);
    if (decisionMaker?.customerPersonId) {
      this.previousDecisionMakerId = decisionMaker.customerPersonId;
    }
}

  public getFormArrayByRole(role: string): FormArray {
    switch (role) {
      case 'COMPANY_OWNER':
        return this.getCompanyOwnerArray();
      case 'ADMINISTRATION':
        return this.getAdministratorsArray();
      case 'PROJECT_MANAGER':
        return this.getProjectManagerArray();
      case 'TECHNICAL_RESPONSIBLE':
        return this.getTechnicalResponsibleArray();
      default:
        throw new Error(`Unknown role: ${role}`);
    }
  }

  getRoles(): string[] {
    return ['COMPANY_OWNER', 'ADMINISTRATION', 'PROJECT_MANAGER', 'TECHNICAL_RESPONSIBLE'];
  }

  updateAccountAndSendCredentials(contact: any): void {
    if (!contact || !contact.customerPersonId) {
      this.showAlertInfo('danger', 'Invalid contact information');
      this.alertNotificationService.error('Invalid contact information');
      return;
    }

    const emptyData = {};

    this.customersService.updateAccountSendCredentialToEmail(this.clientId, contact.customerPersonId, emptyData).subscribe({
      next: (response: any) => {
        if (response && response.status && response.status.code === 200) {
          this.alertNotificationService.success('Account updated and credentials sent to email successfully');
          this.showAlertInfo('success', 'Account updated and credentials sent to email successfully');
          this.loadClientPersons();
        }
      },
      error: (error: any) => {
        const errorMessage = error?.error?.error?.message || 'Failed to update account and send credentials';
        this.alertNotificationService.error(errorMessage);
        this.showAlertInfo('danger', `Error: ${errorMessage}`);
        console.error('Error updating account and sending credentials:', error);
      }
    });
  }

  formatUpdateTime(dateString: string): string {
    if (!dateString) {
      return '';
    }

      return this.commonService.formatDate(new Date(dateString));
    }

  getButtonText(contact: any): string {
    if (!contact.user) {
      return 'Create account and send credentials to email';
    }
    return 'Update account and send credentials to email';
  }

  hasUser(contact: any): boolean {
    return !!contact.user;
  }

  isContactDecisionMaker(contact: AbstractControl): boolean {
    if (contact.get('isDecisionMaker')?.value === true) {
      return true;
    }
    const id = contact.get('customerPersonId')?.value;
    return id != null && id === this.previousDecisionMakerId;
  }

  hasAnyContact(): boolean {
    const roles = this.getRoles();
    return roles.some((role: string) => {
      const arr = this.getFormArrayByRole(role);
      return arr && arr.length > 0;
    });
  }

  getTotalContactCount(): number {
    return this.getRoles().reduce((total, role) => {
      const arr = this.getFormArrayByRole(role);
      return total + (arr ? arr.length : 0);
    }, 0);
  }
}
